<iframe [src]="iFrameUrl | sanitizeResourceUrl"></iframe>